import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";



// Throttle Function
const throttle = (func, delay) => {
    let inProgress = false;
    return (...args) => {
        if (inProgress) {
            return;
        }
        inProgress = true;
        setTimeout(() => {
            func(...args);
            inProgress = false;
        }, delay);
    };
};



// FancyBox
Fancybox.bind("[data-fancybox]", {
    Toolbar: {
        display: {
            left: ["infobar"],
            middle: [],
            right: ["close"],
        },
    },
});



// Set correct body padding
const siteHeader = document.querySelector('.siteHeader');
const siteBody = document.querySelector('body');

const handleHeaderResize = throttle(() => {
    const headerSize = siteHeader.clientHeight;

    siteBody.style.setProperty("--siteHeader-size", headerSize + "px");
}, 100);

window.addEventListener("resize", handleHeaderResize);